"use client";
import { useMemo } from "react";

const useTextColorBasedOnBackground = (tailwindBgColor: string | undefined) => {
  return useMemo(() => {
    if (!tailwindBgColor) return "text-black";

    const hexMatch = tailwindBgColor.match(/\#([A-Fa-f0-9]{6})/);
    if (!hexMatch) return "text-black"; 

    const hexColor = `#${hexMatch[1]}`;

    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 128 ? "text-black" : "text-white";
  }, [tailwindBgColor]);
};

export default useTextColorBasedOnBackground;
